import { cn } from '@/lib/utils';

import { MediaImage } from './media-image';

type SelectedImageProps = {
  mediaId: string;
  fileType?: string | null;
  isSelected: boolean;
  onClick: () => void;
  fileName: string;
};

export const SelectedImage = ({
  mediaId,
  isSelected,
  fileType,
  onClick,
  fileName,
}: SelectedImageProps) => {
  return (
    <button
      type="button"
      key={mediaId}
      className={cn(
        'relative h-full w-full cursor-pointer overflow-hidden whitespace-normal break-words rounded-md'
      )}
      onClick={onClick}
    >
      <MediaImage fileName={fileName} fileType={fileType} mediaId={mediaId} isRounded />
      <div
        className={cn(
          'absolute right-2 top-2 size-6 rounded-full border-2',
          isSelected ? 'border-white bg-primary-light' : 'border-gray-300 bg-white'
        )}
      />
      <p className="w-full max-w-52 truncate text-sm text-text-secondary">{fileName}</p>
    </button>
  );
};
